import { Breadcrumbs, FileUploader, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import React, { useState } from 'react';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import SingleBottomNav from 'components/base/single-bottom-nav';

const CreateGiftCardCategory = () => {
  const [categoryName, setCategoryName] = useState('');
  const [categoryImageUrls, setCategoryImageUrls] = useState<string[]>([]);
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const [imageLimit, setImageLimit] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const breadCrumbs = [
    { name: 'Manage giftcard categories', path: ROUTE_KEYS.GIFTCARD_CATEGORIES },
    {
      name: 'create',
      path: ''
    }
  ];

  const handleSetImageUrls = (urls: string[]) => {
    urls = [...categoryImageUrls, ...urls];
    if (urls.length <= 6) {
      setCategoryImageUrls(urls);
      setImageLimit(false);
    } else {
      setImageLimit(true);
    }
  };

  const createCategory = async () => {
    const payload = {
      name: categoryName,
      image_urls: categoryImageUrls
    };
    try {
      setLoading(true);
      const res = await apiService.post(`vouchers/voucher-categories`, {
        data: payload,
        isInternal: true,
        baseURL: process.env.REACT_APP_ORDER_API
      });
      if (res) {
        toast(<ToastMessage type='success' message='Gift card category created successfully' />);
        navigate(ROUTE_KEYS.GIFTCARD_CATEGORIES);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='max-w-[750px]'>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText
        title='Create new giftcard category'
        description='Need more categories? Get creative here'
      />
      <div className='my-6'>
        <Input
          type='text'
          label='Category name'
          placeholder='Enter name'
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className='mb-4'
        />

        <FileUploader
          token={token}
          fileUrls={categoryImageUrls}
          setFileUrls={handleSetImageUrls}
          label={
            <div className='mb-4'>
              <h3 className='font-medium text-[16px]'>Category Recommended Images </h3>
              <p className='text-[10px] text-[#595959] mt-1'> Maximum of 6 images</p>
            </div>
          }
          isMultiple
          disabled={imageLimit}
          className='mt-5'
        />
      </div>

      {imageLimit && <h3 className='text-sm text-red-5 mb-4'>You cannot add more than 6 images</h3>}

      <SingleBottomNav
        loading={loading}
        onConfirm={createCategory}
        btnDisabled={!categoryName || categoryImageUrls.length === 0}
        buttonText=' Create'
        btnClassName='h-[46px] w-[151px]'
      />
    </div>
  );
};

export default CreateGiftCardCategory;
